export const GET_PAYMENT_FORMULAS = "GET_PAYMENT_FORMULAS";
export const SET_PAYMENT_FORMULAS = "SET_PAYMENT_FORMULAS";
export const GET_PAYMENT_FORMULAS_PARAMS = "GET_PAYMENT_FORMULAS_PARAMS";
export const SET_PAYMENT_FORMULAS_PARAMS = "SET_PAYMENT_FORMULAS_PARAMS";

/* ACTIONS */
export const DELETE_PAYMENT_FORMULAS = "DELETE_PAYMENT_FORMULAS";
export const ADD_PAYMENT_FORMULAS = "ADD_PAYMENT_FORMULAS";
export const PATCH_PAYMENT_FORMULAS = "PATCH_PAYMENT_FORMULAS";

/* ONLY DATA FOR ONE  */
export const GET_PAYMENT_FORMULAS_FOR_ID = "GET_PAYMENT_FORMULAS_FOR_ID";
export const SET_PAYMENT_FORMULAS_FOR_ID = "SET_PAYMENT_FORMULAS_FOR_ID";

/* LOADER */
export const SHOW_LOADER_PAYMENT_FORMULAS = "SHOW_LOADER_PAYMENT_FORMULAS";
export const HIDE_LOADER_PAYMENT_FORMULAS = "HIDE_LOADER_PAYMENT_FORMULAS";

/* ERRORS */
export const SET_ERROR_PAYMENT_FORMULAS = "SET_ERROR_PAYMENT_FORMULAS";
